import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signupData: null,
  loading: false,
  token: null,  // we won't persist this in localStorage anymore
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSignupData(state, action) {
      state.signupData = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    clearAuth(state) {
      state.token = null;
      state.isAuthenticated = false;
      state.signupData = null;
    }
  },
});

export const { setSignupData, setLoading, setToken, clearAuth } = authSlice.actions;

export default authSlice.reducer;
